import { Component, Inject } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { GenericSingleInputDialogModel } from './generic-single-input-dialog.model'

@Component({
    selector: 'app-generic-single-input-dialog',
    templateUrl: './generic-single-input-dialog.component.html',
    styleUrls: ['./generic-single-input-dialog.component.scss'],
})
export class GenericSingleInputDialogComponent {
    constructor(
        private readonly dialogRef: DialogRef<string>,
        @Inject(DIALOG_DATA) readonly data: GenericSingleInputDialogModel
    ) {}

    confirm(inputText: string): void {
        this.dialogRef.close(inputText)
    }

    cancel(): void {
        this.dialogRef.close()
    }
}
